import { Component, Input, OnInit } from '@angular/core';
import { IOperationKPI } from 'src/app/modules/shared/models/operation.model';

@Component({
  selector: 'app-monthly-operations',
  templateUrl: './monthly-operations.component.html',
  styleUrl: './monthly-operations.component.scss',
})
export class MonthlyOperationsComponent {

  @Input() kpis: IOperationKPI[] = [];
  @Input() countersType: 'number' | 'premium';

}
